/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { j as t } from "../../chunks/jsx-runtime.BwWtxLpl.js";
import l from "react";
import { Row as S, Col as d } from "antd";
import { isObject as k } from "radash";
import { Flex as j, Heading as A, Box as D } from "@nubeteck/components";
import { M as o } from "../../chunks/constants.CLW3UOOg.js";
const F = ({
  gap: e = 5,
  children: i,
  columnsByRows: r,
  hideSectionTitles: M = !1
}) => {
  const c = l.useMemo(() => l.Children.toArray(i).reduce((n, s) => {
    if (l.isValidElement(s) && s.props.section) {
      const m = s.props.section;
      return { ...n, [m]: [...n[m] ?? [], s] };
    }
    return n;
  }, {}), [i]), a = l.useMemo(() => ({
    xs: o / (r?.xs ?? 1),
    sm: o / (r?.sm ?? 1),
    md: o / (r?.md ?? 2),
    lg: o / (r?.lg ?? 3),
    xl: o / (r?.xl ?? 4),
    xxl: o / (r?.xxl ?? 6)
  }), [r]), [h, $] = l.useMemo(() => k(e) ? [e?.title ?? 5, e?.section ?? 5] : [e ?? 5, e ?? 5], [e]);
  return /* @__PURE__ */ t.jsx(j, { style: { gap: $, flexDirection: "column" }, children: Object.keys(c).map((n, s) => {
    const m = c[n], f = `FormGrid-Section-${s}`;
    return /* @__PURE__ */ t.jsxs(j, { style: { gap: h, flexDirection: "column" }, children: [
      !M && /* @__PURE__ */ t.jsx(A, { level: 5, children: n }),
      /* @__PURE__ */ t.jsx(S, { gutter: [16, 0], children: m.map((p, C) => {
        const u = `${f}-Input-${C}`;
        return p.props.children?.length ? p.props.children.map(
          (x, G) => /* @__PURE__ */ t.jsx(
            d,
            {
              ...!(x?.props?.span ?? 0) && a,
              span: x?.props?.span ?? 0,
              children: x
            },
            `${u}-${G}`
          )
        ) : /* @__PURE__ */ t.jsx(
          d,
          {
            ...!(p.props?.span ?? 0) && a,
            span: p.props?.span ?? 0,
            children: p
          },
          u
        );
      }) })
    ] }, f);
  }) });
};
F.Section = function(i) {
  return i.section ? /* @__PURE__ */ t.jsx(D, { ...i }) : null;
};
export {
  F as default
};
